import { handleActions } from 'redux-actions';
import {
  OPEN_LEAVE_SURVEY_MODAL,
  CLOSE_LEAVE_SURVEY_MODAL,
  RESET_LEAVE_SURVEY_MODAL,
  DISABLE_LEAVE_SURVEY_MODAL,
} from 'actions/leave-survey-actions';

const initialState = {
  open: false,
  triggered: false,
  disableSurveyModal: false,
  onClose: () => {},
};

const reducer = handleActions(
  {
    [OPEN_LEAVE_SURVEY_MODAL]: (state = initialState, action) => {
      const onClose = action?.payload?.onClose;

      return {
        ...state,
        open: true,
        triggered: true,
        onClose: typeof onClose === 'function' ? onClose : state.onClose,
      };
    },
    [CLOSE_LEAVE_SURVEY_MODAL]: (state = initialState) => {
      // XXX timeout set for callback after the close modal animation
      if (typeof state.onClose === 'function') window.setTimeout(state.onClose, 750);

      return {
        ...state,
        open: false,
      };
    },
    [RESET_LEAVE_SURVEY_MODAL]() {
      return {
        ...initialState,
      };
    },
    [DISABLE_LEAVE_SURVEY_MODAL]: (state = initialState) => ({ ...state, disableSurveyModal: true }),
  },
  initialState
);

export default reducer;
